var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"itemBox"},[_c('div',{staticClass:"appimg",on:{"click":function($event){return _vm.openUrl(_vm.list[0].url)}}},[_c('cjImg',{staticClass:"img",attrs:{"src":_vm._getImgUrl(_vm.list[0].img),"objectFit":"contain","alt":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }